__webpack_require__.p = "https://assets.simple.life/dev/static/develop/d8306fc6/";